export const setFeedData = (data) => {
  return {
    type: 'SET_FEED_DATA',
    payload: data,
  };
};
const initialState = [];

const feedReducer = (state = [], action) => {
  switch (action.type) {
    case 'SET_FEED_DATA':
      return action.payload;
    default:
      return state;
  }
};


export default feedReducer;
